/* "Listen to this article" player. Hand authored, no library.
   One <audio preload="metadata">, a card under the byline, and a sticky bottom bar that
   appears on first play. Nothing autoplays. */
(function () {
  var card = document.getElementById('listen');
  var audio = document.getElementById('listen-audio');
  var bar = document.getElementById('listen-bar');
  if (!card || !audio || !bar) return;

  var playBtns = [card.querySelector('.listen-play'), bar.querySelector('.listen-bar-play')];
  var elapsedEls = [card.querySelector('.listen-elapsed'), bar.querySelector('.listen-bar-elapsed')];
  var totalEls = [card.querySelector('.listen-total'), bar.querySelector('.listen-bar-total')];
  var strip = card.querySelector('.listen-strip');
  var stripFill = card.querySelector('.listen-strip-fill');
  var barProgress = bar.querySelector('.listen-bar-progress');
  var barFill = bar.querySelector('.listen-bar-fill');
  var backBtn = bar.querySelector('.listen-bar-back');
  var fwdBtn = bar.querySelector('.listen-bar-fwd');
  var speedBtn = bar.querySelector('.listen-bar-speed');
  var closeBtn = bar.querySelector('.listen-bar-close');
  var speeds = [1, 1.25, 1.5];
  var speedIdx = 0;
  var barShown = false;

  /* waveform bars: real peaks from data-peaks if present, else a steady pattern */
  (function drawStrip() {
    var peaks = (strip.getAttribute('data-peaks') || '').split(',').map(Number).filter(function (n) { return !isNaN(n); });
    var count = 72;
    if (peaks.length < 8) {
      peaks = [];
      for (var i = 0; i < count; i++) peaks.push(0.35 + 0.55 * Math.abs(Math.sin(i * 0.9) * Math.cos(i * 0.37)));
    }
    /* fit the bar count to the strip so it never overflows on a phone */
    var fit = Math.max(24, Math.min(peaks.length, Math.floor((strip.clientWidth || 300) / 5)));
    if (fit < peaks.length) {
      var re = [];
      for (var k = 0; k < fit; k++) {
        var a = Math.floor(k * peaks.length / fit), z = Math.max(a + 1, Math.floor((k + 1) * peaks.length / fit)), mx = 0;
        for (var q = a; q < z; q++) mx = Math.max(mx, peaks[q]);
        re.push(mx);
      }
      peaks = re;
    }
    var layers = strip.querySelectorAll('.listen-strip-bars');
    for (var l = 0; l < layers.length; l++) {
      var frag = document.createDocumentFragment();
      for (var j = 0; j < peaks.length; j++) {
        var b = document.createElement('i');
        b.style.height = Math.max(12, Math.round(peaks[j] * 100)) + '%';
        frag.appendChild(b);
      }
      layers[l].appendChild(frag);
    }
  })();

  function fmt(s) {
    if (!isFinite(s) || s < 0) s = 0;
    var m = Math.floor(s / 60), r = Math.floor(s % 60);
    return m + ':' + (r < 10 ? '0' : '') + r;
  }
  function setText(els, t) { els.forEach(function (e) { if (e) e.textContent = t; }); }
  function setPlaying(on) {
    playBtns.forEach(function (b) {
      if (!b) return;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? 'Pause' : 'Play');
      b.classList.toggle('is-playing', on);
    });
    card.classList.toggle('is-playing', on);
  }
  function showBar() {
    if (barShown) return;
    barShown = true;
    bar.hidden = false;
    document.body.classList.add('has-listen-bar');
  }
  function hideBar() {
    barShown = false;
    bar.hidden = true;
    document.body.classList.remove('has-listen-bar');
  }
  function toggle() {
    if (audio.paused) {
      showBar();
      var p = audio.play();
      if (p && p.catch) p.catch(function () {});
    } else {
      audio.pause();
    }
  }
  function seekTo(frac) {
    if (!isFinite(audio.duration)) return;
    audio.currentTime = Math.max(0, Math.min(audio.duration, frac * audio.duration));
    paint();
  }
  function skip(delta) {
    if (!isFinite(audio.duration)) return;
    audio.currentTime = Math.max(0, Math.min(audio.duration, audio.currentTime + delta));
    paint();
  }
  function paint() {
    var d = audio.duration, c = audio.currentTime;
    var frac = (isFinite(d) && d > 0) ? c / d : 0;
    setText(elapsedEls, fmt(c));
    if (isFinite(d)) setText(totalEls, fmt(d));
    stripFill.style.clipPath = 'inset(0 ' + (100 - frac * 100) + '% 0 0)';
    barFill.style.width = (frac * 100) + '%';
    strip.setAttribute('aria-valuenow', Math.round(frac * 100));
    barProgress.setAttribute('aria-valuenow', Math.round(frac * 100));
  }

  audio.addEventListener('loadedmetadata', paint);
  audio.addEventListener('durationchange', paint);
  audio.addEventListener('timeupdate', paint);
  audio.addEventListener('play', function () { setPlaying(true); });
  audio.addEventListener('pause', function () { setPlaying(false); });
  audio.addEventListener('ended', function () { setPlaying(false); audio.currentTime = 0; paint(); });

  playBtns.forEach(function (b) { if (b) b.addEventListener('click', toggle); });
  backBtn.addEventListener('click', function () { skip(-15); });
  fwdBtn.addEventListener('click', function () { skip(15); });
  speedBtn.addEventListener('click', function () {
    speedIdx = (speedIdx + 1) % speeds.length;
    audio.playbackRate = speeds[speedIdx];
    speedBtn.textContent = speeds[speedIdx] + 'x';
    speedBtn.setAttribute('aria-label', 'Playback speed ' + speeds[speedIdx] + 'x, press to change');
  });
  closeBtn.addEventListener('click', function () { audio.pause(); hideBar(); });

  function clickSeek(el) {
    return function (ev) {
      var r = el.getBoundingClientRect();
      var x = (ev.touches ? ev.touches[0].clientX : ev.clientX) - r.left;
      seekTo(x / r.width);
    };
  }
  strip.addEventListener('click', clickSeek(strip));
  barProgress.addEventListener('click', clickSeek(barProgress));

  /* Small API for moments.js: jump to a second in this episode and try to play.
     Metadata may not be in yet on a cold tab, so the seek waits for it.
     Resolves true if audio is actually playing, false if the browser blocked it. */
  window.ZebraPlayer = {
    audio: audio,
    card: card,
    showBar: showBar,
    playAt: function (t, wantPlay) {
      return new Promise(function (resolve) {
        function go() {
          try { audio.currentTime = Math.max(0, t); } catch (e) {}
          paint();
          if (!wantPlay) return resolve(false);
          showBar();
          var p = audio.play();
          if (p && p.then) {
            p.then(function () { resolve(true); }).catch(function () { resolve(false); });
          } else {
            resolve(!audio.paused);
          }
        }
        if (audio.readyState >= 1) go();
        else audio.addEventListener('loadedmetadata', go, { once: true });
        /* preload="metadata" usually fires on its own; nudge it if it has not started */
        if (audio.readyState === 0 && audio.load) { try { audio.load(); } catch (e) {} }
      });
    }
  };

  /* keyboard: space toggles when the player has focus; arrows seek on the strips */
  function keys(ev) {
    var t = ev.target;
    if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA')) return;
    if (ev.key === ' ' || ev.key === 'Spacebar') {
      if (t && t.tagName === 'BUTTON') return; /* the button's own click handles it */
      ev.preventDefault(); toggle();
    } else if (ev.key === 'ArrowLeft') { ev.preventDefault(); skip(-15); }
    else if (ev.key === 'ArrowRight') { ev.preventDefault(); skip(15); }
  }
  card.addEventListener('keydown', keys);
  bar.addEventListener('keydown', keys);

  paint();
})();
